<template>
  <div class="stage-details">
    <TextBlockWithLabel
      :text-label="{ text: $t('_web_tournament_stage', 'Stage') }"
      :text-block="{ text: title, size: 0.875 }"
    />

    <TextBlockWithLabel
      :text-label="{
        text: $t('_web_tournament_stage-check-in', 'Stage check in'),
      }"
      :text-block="{ text: checkInTime, size: 0.875 }"
    />

    <TextBlockWithLabel
      :text-label="{ text: $t('_web_tournament_stage-type', 'Type') }"
      :text-block="{
        text: $t(`_web_tournament_stage-type-name_${type}`, type),
        size: 0.875,
      }"
      class="text-capitalize"
    />

    <TextBlockWithLabel
      :text-label="{
        text: $t('_web_tournament_stage_type-of-stage-label', 'Type of stage'),
      }"
      :text-block="{
        text: $t(
          `_web_tournament_stage_available-${availabilityType}`,
          availabilityType
        ),
        size: 0.875,
      }"
      class="text-capitalize"
    />

    <TextBlockWithLabel
      :text-label="{ text: $t('_web_tournament_stage_location', 'Location') }"
      :text-block="{ text: location, size: 0.875 }"
      class="text-capitalize"
    />

    <div v-if="locationImages.length" class="row">
      <div
        v-for="(img, index) in locationImages"
        :key="index"
        class="col-3 mb-4"
      >
        <img
          :src="img"
          class="mw-100 cursor-hand stage-details_map"
          @click="openImage(img)"
        />
      </div>
    </div>

    <TextBlockWithLabel
      :text-label="{
        text: $t('_web_tournament_best-of-final', 'Best of (final match)'),
      }"
      :text-block="{ text: bestOfFinal, size: 0.875 }"
    />

    <TextBlockWithLabel
      :text-label="{
        text: $t('_web_tournament_number-of-rounds', 'Number of rounds'),
      }"
      :text-block="{ text: numberOfRounds, size: 0.875 }"
    />

    <TextBlockWithLabel
      :text-label="{
        text: $t('_web_tournament_3rd_place-label', 'Match for the 3rd place'),
      }"
      :text-block="{
        text: $t(
          `_web_tournament_3rd_place-variant-${match3dPlace}`,
          match3dPlace
        ),
        size: 0.875,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { localDate } from '@/filters/dateTime';
import TextBlockWithLabel from '@/components/text/TextBlockWithLabel';

export default {
  components: {
    TextBlockWithLabel,
  },
  computed: {
    ...mapGetters({ stage: 'currentTournamentStage' }),

    title() {
      return this.$lodash.get(this, 'stage.title') || '-';
    },

    checkInTime() {
      return localDate(this.$lodash.get(this, 'stage.date_start'));
    },

    type() {
      return this.$lodash
        .get(this, 'stage.block_configuration.type', '')
        .replace('_', ' ');
    },

    availabilityType() {
      return this.$lodash.get(this, 'stage.availability_type') || '-';
    },

    location() {
      return this.$lodash.get(this, 'stage.location.location_name') || '-';
    },

    locationImages() {
      return this.$lodash
        .get(this, 'stage.map_of_venue', [])
        .map(({ image }) => image);
    },

    numberOfRounds() {
      return `${this.$lodash.get(
        this,
        'stage.block_configuration.best_of',
        0
      )}`;
    },

    match3dPlace() {
      return this.$lodash.get(this, 'stage.block_configuration.match_3rd_place')
        ? 'Yes'
        : 'No';
    },

    bestOfFinal() {
      return `${this.$lodash.get(
        this,
        'stage.block_configuration.best_of_final'
      ) || '-'}`;
    },
  },
  created() {
    this.setCurrentTournamentStage(this.$route.params.stageID);
  },
  methods: {
    ...mapMutations(['setCurrentTournamentStage']),
    ...mapActions('mediaplayer', ['openImage']),
  },
};
</script>

<style lang="scss">
.stage-details {
  &_map {
    border-radius: 0.25rem;
  }
}
</style>
